'use client';

import { isValidElement, cloneElement } from "react";
function cloneWithProps(children, props) {
  if (!isValidElement(children)) return null;
  return cloneElement(children, props);
}
export {
  cloneWithProps
};
